import src from "IMAGE";
export default { src, width: 400, height: 78, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AKrkzpnX5uM74uLmHeLi5R/h4eUg5ubpG+Dg5CDi4uYcALHm0ozc6eYz5eXoGuLi5h7g4OQh5eXpG9/f4yHt7e8S5PYtGM6l09MAAAAASUVORK5CYII="};
